import { ref } from 'vue';
import { flowsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';
import { routes } from '~/routes';

export const useResourcesFlow = createGlobalState(() => {
    const flows = ref(new Map());

    const reset = () => {
        flows.value = new Map();
    };

    routes.afterEach((to, from) => {
        if (to.path !== from?.path) {
            reset();
        }
    });

    const loadFlow = async (teamId: number, flowId: string) => {
        if (flows.value.has(flowId)) {
            return;
        }

        flows.value.set(flowId, null);

        try {
            const response = await flowsClient.get(teamId, flowId);
            flows.value.set(flowId, response.data);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        flows,
        loadFlow,
        reset,
    };
});
